import designTokens from '@customink/design-tokens/build/js/designTokens';
import { Box, Typography } from '@customink/pigment-react';
import { styled } from '@customink/pigment-react/lib/themeCustomink';

const StyledTypography = styled(Typography)({
  fontSize: '16px',
  lineHeight: '24px',
});

type InfoTextProps = {
  showMigrationNotice?: boolean;
};

export function InfoText({ showMigrationNotice }: InfoTextProps) {
  return (
    <>
      <StyledTypography
        component="h5"
        fontWeight="bold"
        lineHeight="20px"
        mb="20px"
        mt={3}
      >
        Choose one of two ways to verify your tax exemption:
      </StyledTypography>
      <StyledTypography
        component="h5"
        fontWeight="bold"
        lineHeight="20px"
        mb="10px"
      >
        <ol style={{ paddingLeft: 20, margin: '0' }}>
          <li>
            Continue with Purchase - Verify Later and Receive Sales Tax Refund
          </li>
        </ol>
      </StyledTypography>
      <StyledTypography mb="20px" paragraph>
        Return to the cart and complete your purchase. We&apos;ll email you
        instructions for verifying tax exemption. Once approved, we&apos;ll
        refund any paid sales tax.
      </StyledTypography>
      <StyledTypography
        component="h5"
        fontWeight="bold"
        lineHeight="20px"
        mb="10px"
      >
        <ol style={{ paddingLeft: 20, margin: '0' }}>
          <li value={2}>Verify Now - Apply Tax Exemption At Checkout</li>
        </ol>
      </StyledTypography>
      <StyledTypography paragraph>
        Submit your certificate through our portal, and we&apos;ll notify you
        once your tax exemption is approved. Approval can take as little as a
        few minutes, but may take up to 3 business days.
      </StyledTypography>
      {showMigrationNotice && (
        <Box>
          <Typography
            paragraph
            sx={{
              p: '14px 16px',
              mt: '4px',
              background: designTokens.color.gray.light.value,
            }}
            variant="bodyLong2"
          >
            Only valid tax exemption certificates are accepted. Other tax forms,
            such as IRS W-9s or similar documents, may not be applicable.
          </Typography>
        </Box>
      )}
    </>
  );
}
